import $ from 'jquery';
import "./index.scss";

import initHeader from './js/header';
import initSiteBackground from './js/siteBackground';
import InfoBoxes from './js/InfoBoxes';
import Infographic from "./js/infographic";
import ContactForm from "./js/contactForm";
import ContactFormLP from "./js/contactFormLP";
import CookieBanner from "./js/cookieBanner";
import ArticleDisplay from "./js/articleDisplay";
import initLazyLoadImages from "./js/lazyLoadImages";

$.event.special.touchstart = {
    setup: function(_, ns, handle) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
$.event.special.touchmove = {
    setup: function(_, ns, handle) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
$.event.special.wheel = {
    setup: function(_, ns, handle) {
        this.addEventListener("wheel", handle, { passive: true });
    }
};
$.event.special.mousewheel = {
    setup: function(_, ns, handle) {
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

initHeader();
initSiteBackground();
initLazyLoadImages();
InfoBoxes();
Infographic();
ContactForm();
ContactFormLP();
CookieBanner();
ArticleDisplay();